import Vue from 'vue'
import Router from 'vue-router'
// import Index from '@/views/index.vue'
import Layout from '@/layout'

Vue.use(Router)

//解决vue路由重复导航错误
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

//切换路由自动页面置顶
const scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  // if (savedPosition) {
  //   return savedPosition;
  // } else {
    return {x: 0, y: 0}
  // }
}

export default new Router({
  scrollBehavior,
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: 'index',
      children: [
        {
          path: 'index',
          component: () => import('@/views/index.vue'),
          name: 'Index',
        }
      ]
    },
    {
      path: '/bid',
      component: Layout,
      children: [
        {
          path: '/',
          component: () => import('@/views/bid/index.vue'),
          name: 'Bid',
        },
        {
          path: '/bid/detail',
          component: () => import('@/views/bid/detail.vue'),
          name: 'BidDetail',
        }
      ]
    },
    {
      path: '/help',
      component: Layout,
      children: [
        {
          path: '/',
          component: () => import('@/views/help/index.vue'),
          name: 'Help',
        }
      ]
    },
    {
      path: '/important',
      component: Layout,
      children: [
        {
          path: '/',
          component: () => import('@/views/important/index.vue'),
          name: 'Important',
        },
        {
          path: '/important/detail',
          component: () => import('@/views/important/detail.vue'),
          name: 'ImportantDetail',
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/login/index.vue'),
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import('@/views/register/index.vue'),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js